import { render, staticRenderFns } from "./businessCardVisit.vue?vue&type=template&id=1c47e86b&scoped=true&"
import script from "./businessCardVisit.vue?vue&type=script&lang=js&"
export * from "./businessCardVisit.vue?vue&type=script&lang=js&"
import style0 from "./businessCardVisit.vue?vue&type=style&index=0&id=1c47e86b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c47e86b",
  null
  
)

export default component.exports